module.exports = __webpack_public_path__ + "643d7f44269cfec390961bac47b9d642.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/small/raisa-cuevas.jpg
// module id = 478
// module chunks = 0